export const REQUEST_GLOBALIZE_DATA = 'Internationalise/REQUEST_GLOBALIZE_DATA';
export const RECEIVED_GLOBALIZE_DATA = 'Internationalise/RECEIVED_GLOBALIZE_DATA';
export const UPDATE_GLOBALIZE_DATA = 'Internationalise/UPDATE_GLOBALIZE_DATA';
// export const REQUEST_GLOBALIZE_DATA = 'Internationalise/REQUEST_GLOBALIZE_DATA';
export const REQUEST_UPDATE_HASH_MAP = 'Internationalise/REQUEST_UPDATE_HASH_MAP';